<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Alert, AlertV2 } from '@Shelly/shelly-design-system';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import {
		getSharedHomeManagedCopy,
		type SharedHomeManagedContext,
	} from 'src/helpers/houses/shared_home_messaging_helpers';

	export let context: SharedHomeManagedContext = 'generic';
	let className = '';
	export { className as class };

	$: copy = getSharedHomeManagedCopy(context);
	$: heading = $format(copy.headingKey, { default: copy.headingDefault });
	$: message = $format(copy.messageKey, { default: copy.messageDefault });
</script>

{#if $showNewLayout}
	<AlertV2 class={className} {heading} {message} />
{:else}
	<Alert type="info" class={className} {heading} {message} isHeadingBold />
{/if}
